import { useState } from "react";

export function useCopyToClipboard(text, defaultMsg = "Copy") {
  const [tooltip, setTooltip] = useState(defaultMsg);
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTooltip("Copied");
      setTimeout(() => {
        reset();
      }, 2000);
    } catch {
      setTooltip("Failed to copy to clipboard! Please try manually.");
    }
  };

  const reset = () => {
    setTooltip(defaultMsg);
    setCopied(false);
  };

  return { tooltip, copy, reset, copied };
}
